import { useState } from "react";

const UseDialogBox = () => {
  const [showDialogBox, setShowDialogBox] = useState(false);
  return { showDialogBox, setShowDialogBox };
};

export default UseDialogBox;
